module.exports = __webpack_public_path__ + "img/jean-fabric-background.7a2afc77.png";